import { axios } from '../interceptors';
import { CustomerDetail } from '../models/customer';

class CustomerService {
  private static baseUrl = '/customer';

  public static async getCustomerDetail() {
    const response = await axios.get<CustomerDetail>(this.baseUrl);
    return response.data;
  }
}

export { CustomerService };
